module.exports = __webpack_public_path__ + "static/media/block.087b7c0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/block.svg
// module id = 1119
// module chunks = 38